export function sum(A: number[]): number {
  let sum = 0;
  for (let i = 0; i < A.length; i++) {
    sum += A[i];
  }
  return sum;
}

export function humanizeSeconds(seconds: number | null, long = false, numParts = 2) {
  if (seconds === null) return null;

  const days = Math.floor(seconds / (3600 * 24));
  const hours = Math.floor((seconds - days * 3600 * 24) / 3600);
  const minutes = Math.floor((seconds - days * 3600 * 24 - hours * 3600) / 60);
  const secs = seconds - days * 3600 * 24 - hours * 3600 - minutes * 60;

  const days_string = long ? `${days} days` : `${days}d`;
  const hours_string = long ? `${hours} hours` : `${hours}h`;
  const minutes_string = long ? `${minutes} minutes` : `${minutes}m`;
  const seconds_string = long ? `${secs} seconds` : `${secs}s`;

  let parts;
  if (days > 0) {
    parts = [days_string, hours_string, minutes_string, seconds_string];
  } else if (hours > 0) {
    parts = [hours_string, minutes_string, seconds_string];
  } else if (minutes > 0) {
    parts = [minutes_string, seconds_string];
  } else {
    parts = [seconds_string];
  }

  if (parts.length > numParts) {
    parts = parts.slice(0, numParts);
  }

  return parts.join(long ? ", " : "");
}
